var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 20,
      height: 20,
      cursor: "pointer!important"
    },
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.75 10a8.25 8.25 0 1 0 16.5 0 8.25 8.25 0 0 0-16.5 0m1.356 6.894A9.75 9.75 0 1 1 16.894 3.106 9.75 9.75 0 0 1 3.106 16.894M7.47 12.53a.75.75 0 0 1 0-1.06L8.94 10 7.47 8.53a.75.75 0 0 1 1.06-1.06L10 8.94l1.47-1.47a.75.75 0 1 1 1.06 1.06L11.06 10l1.47 1.47a.75.75 0 1 1-1.06 1.06L10 11.06l-1.47 1.47a.75.75 0 0 1-1.06 0"
  })));
};
export default SvgCross;